export default __webpack_public_path__ + "static/media/profile_tip_business_requests.1657804a.svg";